export const environment = {
    production: true,
    API_ENDPOINT: 'https://api.smartpricing.costa-platform.com/api/',
    CLIENT_ID: 'cbd709c1-3c5d-4f1e-a450-c3db67bffa70',
    TENANT_ID: '04ed63ba-9902-48da-b4cd-52b94b3a487e',
    REDIRECT_URL: 'https://smartpricing.costacoffee.com/',
    AUDIANCE: 'api://a40c7284-a682-4cda-9452-00154bcb12d7/pricing-app-scope',
    IS_AUTHENTICATED:true
  };